import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-single-post',
  templateUrl: './single-post.component.html',
  styleUrls: ['./single-post.component.scss']
})
export class SinglePostComponent implements OnInit {

  imgSingleBlog = require('../../../images/single-blog-image.jpg');

  constructor() { }

  ngOnInit() {
  }

}
